export enum SurveyPageType {
  DEFAULT = 'default',
  RATING = 'rating',
}
